<template>
  <el-dialog
    :title="!dataForm.id ? '新增' : !disabled ? '修改' : '查看'"
    :close-on-click-modal="false"
    :visible.sync="visible"
  >
    <el-form
      :model="dataForm"
      :rules="dataRule"
      ref="dataForm"
      @keyup.enter.native="dataFormSubmit()"
      label-width="80px"
    >
      <el-form-item label="获取渠道" prop="getway">
        <el-radio-group v-model="dataForm.getway" :disabled="disabled">
          <el-radio :label="0"> 提前订餐 </el-radio>
          <el-radio :label="1"> 按日超额支付 </el-radio>
          <el-radio :label="2"> 按月超额支付 </el-radio>
          <el-radio :label="3"> 积分兑换比例 </el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="参数名" prop="rewardKey">
        <el-input
          v-model="dataForm.rewardKey"
          :disabled="disabled"
          placeholder="参数名"
        ></el-input>
      </el-form-item>
      <el-form-item label="兑换比例/积分量" prop="value">
        <el-input
          v-model="dataForm.value"
          :disabled="disabled"
          placeholder="兑换比例/积分量"
        ></el-input>
      </el-form-item>
      <el-form-item label="描述" prop="remarkes">
        <el-input
          v-model="dataForm.remarkes"
          :disabled="disabled"
          placeholder="描述"
        ></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button v-if="!disabled" type="primary" @click="dataFormSubmit()"
        >确定</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      disabled: false,
      visible: false,
      dataForm: {
        id: 0,
        getway: '',
        rewardKey: '',
        value: '',
        remarkes: '',
      },
      dataRule: {
        name: [{ required: true, message: '名称不能为空', trigger: 'blur' }],
      },
    };
  },
  methods: {
    init(id, disabled) {
      this.disabled = disabled;
      this.dataForm.id = id || '';
      this.visible = true;
      this.$nextTick(() => {
        this.$refs['dataForm'].resetFields();
        if (this.dataForm.id) {
          this.$http({
            url: `/tc/pointsrewardtype/info/${this.dataForm.id}`,
            method: 'get',
          }).then(({ data }) => {
            if (data && data.code === 0) {
              this.dataForm = data.pointsrewardtype;
            }
          });
        }
      });
    },
    // 表单提交
    dataFormSubmit() {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          this.$http({
            url: `/tc/pointsrewardtype/${
              !this.dataForm.id ? 'save' : 'update'
            }`,
            method: 'post',
            data: this.dataForm,
          }).then(({ data }) => {
            if (data && data.code === 0) {
              this.$message({
                message: '操作成功',
                type: 'success',
                duration: 1500,
              });
              this.visible = false;
              this.$emit('refreshDataList');
            }
          });
        }
      });
    },
  },
};
</script>
